import generateStore from './generateStore.js'

// #467 — findings of one sheet-import run (admin only; 404 in other orgs).
export default (app) => generateStore('sheet_sync/findings', app)
